'use client'

import { useScrollToHash } from '@/hooks/useScrollToHash'

export const ScrollToHashClient = () => {
  useScrollToHash()
  return null
}

export default ScrollToHashClient
